import React from 'react';
import cn from 'clsx';

import Typography from '../../library/typography/typography';

import styles from './flag.scss';

interface FlagProps {
  children: React.ReactNode;
  className?: string;
  renderIcon?: React.ReactNode;
}

function Flag(props: FlagProps) {
  const { children, className = '', renderIcon } = props;

  return (
    <div
      className={cn(styles['container'], `flag ${className}`)}
      data-testid="flag-container"
    >
      {renderIcon}
      <Typography
        className={cn(styles['text'], 'flag__text')}
        data-testid="flag__text"
        size="small"
        tag="span"
        weight="bold"
      >
        {children}
      </Typography>
    </div>
  );
}

export default Flag;
